<template>
  <v-container fluid pa-0 v-if="$hasMatchingTenantRoles(['tenant_admin'])">
    <v-scroll-x-reverse-transition group hide-on-leave>
      <v-row no-gutters v-if="step === 0" key="0" class="mt-xl-16">
        <v-col cols="12">
          <v-row align="start" justify="center" no-gutters>
            <v-col cols="12" md="5" class="pt-md-5">
              <div class="image-holder">
                <div class="grey lighten-5 rounded-circle" style="width: 100%; height: 100%">
                  <v-slide-x-transition>
                    <v-row v-if="imageIsLoaded" align="start" class="fill-height" justify="center" no-gutters>
                      <img src="img/undraw_survey_05s5.svg" style="height: 80%" />
                    </v-row>
                  </v-slide-x-transition>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="7">
              <dismiss-onboarding-button />
              <div class="text-left">
                <div class="title text-sm-h5 font-weight-bold mt-5 mb-5">
                  {{ $t('onboarding.personnel_analysis') }}
                </div>
                <div class="subtitle-2 text-sm-subtitle-1">{{ $t('onboarding.personnel_analysis_info') }}</div>
                <div class="subtitle-2 text-sm-subtitle-1 mt-4">
                  {{ $t('onboarding.personnel_analysis_info2') }}
                  <ol class="my-3 ml-3">
                    <li>{{ $t('onboarding.personnel_capability') }}</li>
                    <li>{{ $t('onboarding.efficiency_of_operations') }}</li>
                    <li>{{ $t('onboarding.leadership') }}</li>
                    <li>{{ $t('onboarding.company_culture') }}</li>
                  </ol>
                </div>
                <div class="subtitle-2 text-sm-subtitle-1 mt-4">
                  {{ $t('onboarding.personnel_analysis_info3') }}
                </div>
                <div>
                  <basic-button @click="step = 1" color="primary" class="mt-10" outlined>
                    <v-icon left>mdi mdi-arrow-right</v-icon>
                    {{ $t('onboarding.continue') }}
                  </basic-button>
                </div>
                <div class="text-body-2 text-sm-body-1 primary--text text--darken-1 mt-10">
                  {{ $t('onboarding.after_analysis_is_done') }}
                </div>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row v-if="step === 1 && !survey" key="1" no-gutters>
        <v-col cols="12" md="10" offset-md="1" lg="8" offset-lg="2">
          <dismiss-onboarding-button />
          <div class="title text-sm-h5 font-weight-bold mt-5 mb-5">
            {{ $t('onboarding.create_personnel_survey') }}
          </div>
          <create-survey ref="createSurvey" type="PERSONNEL" stay-after-save @survey-saved="handleSurveySaved" />
          <basic-button :loading="savingSurvey" @click="saveSurvey" color="primary" block class="mt-4">
            <v-icon>mdi mdi-check</v-icon>
            {{ $t('onboarding.save_analysis') }}
          </basic-button>
        </v-col>
      </v-row>

      <v-row no-gutters v-if="step === 1 && survey" key="2">
        <v-col cols="12" md="10" offset-md="1" lg="8" offset-lg="2">
          <v-row align="start" justify="center" no-gutters>
            <v-col cols="12">
              <div class="image-holder">
                <div class="grey lighten-5 rounded-circle" style="width: 100%; height: 100%">
                  <v-slide-x-transition>
                    <v-row align="start" class="fill-height" justify="center" no-gutters>
                      <img src="img/undraw_completing_re_i7ap.svg" style="height: 80%" />
                    </v-row>
                  </v-slide-x-transition>
                </div>
              </div>
            </v-col>
            <v-col cols="12">
              <div class="text-left">
                <div class="title text-sm-h5 font-weight-bold mt-5 mb-5 text-center">
                  {{ $t('onboarding.personnel_survey_created') }}
                </div>
                <div class="subtitle-2 text-sm-subtitle-1 mb-10 text-center">{{ $t('onboarding.personnel_survey_created_info') }}</div>
                <div>
                  <share-survey-card :survey="survey" :teams="teams" elevation="2" @refresh-teams="reloadTeams" />
                </div>
                <div>
                  <basic-button @click="goToNextStep" color="primary" block class="mt-10" outlined>
                    <v-icon left>mdi mdi-arrow-right</v-icon>
                    {{ $t('onboarding.continue') }}
                  </basic-button>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-scroll-x-reverse-transition>

    <img src="img/undraw_completing_re_i7ap.svg" style="display: none" />
    <img src="img/undraw_survey_05s5.svg" style="display: none" @load="imageIsLoaded = true" />
  </v-container>
</template>
<script>
import BasicButton from '@/components/BasicButton';
import CreateSurvey from '@/components/Tenant/CreateSurvey/CreateSurvey';
import ShareSurveyCard from '@/components/Tenant/ShareSurveyCard';
import DismissOnboardingButton from '@/components/Tenant/Onboarding/DismissOnboardingButton';
export default {
  name: 'CreatePersonnelAnalysis',
  components: { DismissOnboardingButton, ShareSurveyCard, CreateSurvey, BasicButton },
  props: {
    teams: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      imageIsLoaded: false,
      step: 0,
      savingSurvey: false,
      survey: null,
    };
  },
  methods: {
    goToNextStep() {
      this.$emit('next-step');
    },
    async saveSurvey() {
      this.savingSurvey = true;
      await this.$refs.createSurvey.saveSurvey();
      this.savingSurvey = false;
    },
    reloadTeams() {
      this.$emit('reload-teams');
    },
    handleSurveySaved(survey) {
      this.survey = survey;
    },
  },
};
</script>

<style lang="scss" scoped>
.image-holder {
  position: relative;
  margin: auto;
  width: 245px;
  height: 245px;
}

@media screen and (min-width: 1500px) {
  .image-holder {
    width: 285px;
    height: 285px;
  }
}
</style>
